import { createSlice } from "@reduxjs/toolkit";

const initialDistributionMergingState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  distributionMergingForEdit: undefined,
  lastError: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const distributionMergingSlice = createSlice({
  name: "distributionMerging",
  initialState: initialDistributionMergingState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // findDistributionMerging
    distributionMergingsFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = action.payload;
    },
    // Set to default state actionLoading & error
    distributionMergingReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.entities = [];
    },
  },
});
